import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

export interface QuizAnalytics {
  ukupno_takmicara: number;
  prosecan_rezultat: number;
  najbolji_rezultat: number;
  najbrzi_kviz_sekunde: number;
  prosecno_vreme_sekunde: number;
}

const getQuizAnalytics = async (date: string): Promise<QuizAnalytics | null> => {
  try {
    const config: AxiosRequestConfig = {
      method: "GET",
      // Lokalno (development)
    //   url: `http://localhost:6002/api/ultra/politehnika/analitika`,
      
      // Produkcija
      url: `https://politehnika-back.firebird.rs/api/ultra/politehnika/analitika`,
      headers: {
        "Content-Type": "application/json",
      },
      params: {
        date,
      },
    };

    const response: AxiosResponse = await axios(config);
    const { data } = response;
    const { code } = data;

    if (code !== 200) {
      return null;
    }

    // Konvertuj stringove u brojeve (PostgreSQL može da vrati numeričke vrednosti kao stringove)
    const analyticsData = data.data;
    return {
      ukupno_takmicara: Number(analyticsData.ukupno_takmicara) || 0,
      prosecan_rezultat: Number(analyticsData.prosecan_rezultat) || 0,
      najbolji_rezultat: Number(analyticsData.najbolji_rezultat) || 0,
      najbrzi_kviz_sekunde: Number(analyticsData.najbrzi_kviz_sekunde) || 0,
      prosecno_vreme_sekunde: Number(analyticsData.prosecno_vreme_sekunde) || 0,
    };
  } catch (error) {
    console.error("Error fetching quiz analytics:", error);
    return null;
  }
};

export default getQuizAnalytics;

